/** Shared UI tokens for admin enquiry pages (matches Students / PendingUsers). */

export const fieldStyle = {
  padding: '12px 16px',
  border: '1.5px solid #e2e8f0',
  borderRadius: '8px',
  fontSize: '14px',
  outline: 'none',
  fontFamily: 'inherit',
  backgroundColor: '#fff',
};

export const STATUS_STYLES = {
  new: { bg: '#eef2ff', color: '#667eea', border: '#c7d2fe' },
  contacted: { bg: '#ebf8ff', color: '#3182ce', border: '#bee3f8' },
  follow_up: { bg: '#fffaf0', color: '#dd6b20', border: '#feebc8' },
  converted: { bg: '#f0fff4', color: '#38a169', border: '#c6f6d5' },
  lost: { bg: '#fff5f5', color: '#e53e3e', border: '#fed7d7' },
};

export const INTEREST_STYLES = {
  hot: { bg: '#fff5f5', color: '#c53030', border: '#fed7d7' },
  warm: { bg: '#fffaf0', color: '#dd6b20', border: '#feebc8' },
  cold: { bg: '#f7fafc', color: '#718096', border: '#e2e8f0' },
};

export function StatusBadge({ label, variant = 'status', value }) {
  const palette =
    variant === 'interest' ? INTEREST_STYLES[value] : STATUS_STYLES[value];
  if (!palette || !label) return null;

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 10px',
        backgroundColor: palette.bg,
        color: palette.color,
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: '600',
        border: `1px solid ${palette.border}`,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}

export const thStyle = {
  padding: '12px',
  textAlign: 'left',
  fontSize: '13px',
  fontWeight: '700',
  color: '#2d3748',
};

export const tdStyle = {
  padding: '16px 12px',
  fontSize: '13px',
  color: '#4a5568',
};
